import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchEmptyState'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'No results found',
  },
  content: {
    id: `${scope}.content`,
    defaultMessage:
      "Check your spelling or try a different keyword to find what you're looking for.",
  },
})
